import { otsBaseApi } from '../store/ots-api';
/** Identity is always scoped to the subject's tenant, including in the RTK Query cache key. */
export type ComplianceSubject = {
  kind: 'ticket' | 'pickup';
  id: string;
  tenantCode?: string;
};

/** A provider represents an agency's program/form. Codes are open so new agencies need no shell changes. */
export type ComplianceProvider = {
  provider: string;
  displayName: string;
  subtitle?: string;
  regulator?: string;
  jurisdiction?: string;
  status?: string;
  available: boolean;
  reason?: string;
};

export type RegionComplianceProvider = {
  provider: string;
  displayName: string;
  capabilities: string[];
};
export const rrcProfileCapabilities = (
  providers?: RegionComplianceProvider[]
) =>
  new Set(
    providers
      ?.filter((p) => p.provider === 'TEXAS_RRC_PROFILES')
      .flatMap((p) => p.capabilities) ?? []
  );

export const complianceApi = otsBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRegionComplianceProviders: builder.query<
      RegionComplianceProvider[],
      { regionId: string; tenantCode?: string }
    >({
      query: ({ regionId, tenantCode }) => ({
        url: `/regions/${encodeURIComponent(regionId)}/compliance/providers`,
        params: { tenantCode },
      }),
    }),
    getComplianceProviders: builder.query<
      ComplianceProvider[],
      ComplianceSubject
    >({
      query: (subject) => ({
        url: `/${
          subject.kind === 'ticket' ? 'tickets' : 'transports'
        }/${encodeURIComponent(subject.id)}/compliance/providers`,
        params: { tenantCode: subject.tenantCode },
      }),
    }),
  }),
});
export const {
  useGetComplianceProvidersQuery,
  useGetRegionComplianceProvidersQuery,
} = complianceApi;
